
import React from 'react';
import { LucideIcon } from 'lucide-react';

interface PlatformProps {
  icon: LucideIcon;
  name: string;
}

const PlatformItem = ({ icon: Icon, name }: PlatformProps) => (
  <div className="flex items-center gap-3 bg-white/80 backdrop-blur-sm border border-border/50 rounded-lg px-4 py-3 shadow-sm transition-all hover:shadow-md hover:scale-[1.02]">
    <div className="p-2 bg-primary/10 rounded-md">
      <Icon className="h-5 w-5 text-primary" />
    </div>
    <span className="font-medium">{name}</span>
  </div>
);

export default PlatformItem;
